import {GenericModal} from '../../generic-modal';

const CORPO_CLIENT_API = '/api/company/freelance-client-compatibility';

// bar nav quote creation
Hop.defineModule('modal-proposal-blocked-corpo-draft', (root) => {
    const $root = $(root);
    const parentForm = $root.closest('form');
    let clientFirstName;
    let clientCompanyId;

    Hop.events.on('proposal-draft:company-updated', (data) => {
        clientFirstName = data.clientFirstName;
        clientCompanyId = data.clientCompanyId;
    });

    $root.click((e) => {
        e.preventDefault();
        checkIfFreelanceCanWorkWithClient(clientCompanyId, clientFirstName, () => parentForm.submit());
    });
});

function checkIfFreelanceCanWorkWithClient(clientCompanyId, clientName, actionProposalAllowed) {
    const popup = new GenericModal({
        title: Hop.message('business.proposal.draft.modal.freelance.not.compliant.title'),
        message: Hop.message('business.proposal.draft.modal.freelance.not.compliant.content', Hop.escapeHtml(clientName)),
        confirmLabel: Hop.message('business.proposal.draft.modal.freelance.not.compliant.button'),
        notabene: Hop.message('business.proposal.draft.modal.freelance.not.compliant.notabene'),
        illustration: '//dam.malt.com/mission/lock',
    });

    Hop.get(CORPO_CLIENT_API + `?clientCompanyId=${clientCompanyId}`)
        .then((data) => data.json())
        .then((response) => {
            if (!response.canWorkWithCompany) {
                popup.show((result) => {
                    if (result) {
                        window.location.href = `/freelancer/company/${response.freelanceCompanyId}`;
                    }
                });
            } else {
                actionProposalAllowed();
            }
        });
}
